/**
 * BLOCK - PRODUCT FORM - LISTENERS
 */

setupEventListenersForProductForm();

// Creates the event listeners
function setupEventListenersForProductForm() {
  // On changing on a variant option select
  document.querySelectorAll('.product__variants select.option-selector').forEach((element) => {
    element.addEventListener('change', changeProductFormSelectOptionHandler);
  });
  
  // On clicking on a variant option swatch
  document.querySelectorAll('.product__variants .swatch-input').forEach((element) => {
    element.addEventListener('click', clickProductFormSwatchOptionHandler);
  });
  
  // On clicking on the - button of the quantity in the product form 
  document.querySelectorAll('.product-form [data-action="sub-product"], .product-quantity-selector [data-action="sub-product"]').forEach((element) => {
    element.addEventListener('click', clickProductFormSubQuantityHandler);
  });
  
  // On clicking on the + button of the quantity in the product form 
  document.querySelectorAll('.product-form [data-action="add-product"], .product-quantity-selector [data-action="add-product"]').forEach((element) => {
    element.addEventListener('click', clickProductFormAddQuantityHandler);
  });
  
  // On clicking on the add to cart button in the product form
  document.querySelectorAll('[data-action="add-to-cart"]').forEach((element) => {
    element.addEventListener('click', clickProductFormAddToCartHandler);
  });
}

// On page load
window.addEventListener('DOMContentLoaded', domContentloadedHandler);
  
// When a variant has changed
document.addEventListener('variant.changed', variantChangedHandler);

/**
 * BLOCK - PRODUCT FORM - GENERAL
 */

// On dom content loaded
function domContentloadedHandler() {
  triggerSelectedVariantChange();
}

// When a variant has changed
function variantChangedHandler() {  
  var detail = event.detail,
      target = detail.target,
      variant = detail.variant;

  // Add custom logic here
  console.log("Variant has changed");
}

// On changing on a variant option select
function changeProductFormSelectOptionHandler() {  
  handleSelectedVariantChange();
}

// On clicking on a variant option swatch
function clickProductFormSwatchOptionHandler() {    
  handleSelectedVariantChange();
}

// On clicking on the - button of the quantity in the product form 
function clickProductFormSubQuantityHandler() {
  subQuantity();
  updateSubscriptionPrices();
}

// On clicking on the + button of the quantity in the product form 
function clickProductFormAddQuantityHandler() {
  addQuantity();
  updateSubscriptionPrices();
}

// On clicking on the add to cart button in the product form
function clickProductFormAddToCartHandler() {
  event.preventDefault();
  addToCartFromProductForm();
}

// Triggers a change of selected variant to update availability state
function triggerSelectedVariantChange() {
  if (isPage('/products/')) {
    var productVariantsContainers = document.querySelectorAll('.block__product-form .product-form, .block__product-variant-picker');
    
    productVariantsContainers.forEach((element) => {
      var input = element.querySelector('.option-selector:not([data-action="redirect"]) [selected="selected"] input');
  
      if (input !== null) input.click();
    });
  }
}

// Handles a change of selected variant
function handleSelectedVariantChange() {
  var target = event.currentTarget,
      product = '' ;

  if (!isInProductCard(target)) {
    product = ProductJSON;
  } else {
    var itemProduct = target.closest('.item-product'),
        id = itemProduct.dataset.productId;
    
    product = ProductsJSON.find(element => element.id == id);
  }
  
  var productVariants = target.closest('.product__variants'),
      oldVariant = getVariantFromOptions(productVariants, product);
  
  selectProductOption();
  
  var currentVariant = selectProductNewVariant(productVariants, product);    

  if (currentVariant) {
    updateProductLabels(currentVariant);
    updateProductPrices(currentVariant);
    updateProductInventory(currentVariant);
    updateProductImages(currentVariant);
  }
  
  checkProductVariantAvailability(currentVariant, productVariants);  
  if (!isInProductCard(target)) document.dispatchEvent(new CustomEvent("variant.changed", { detail: { target: target, variant: currentVariant } })); // Triggers an event to be catched for other modifications
}  

// Gets the variant from the selected options
function getVariantFromOptions(productVariants, product) {
  var selectedValues = getCurrentOptions(productVariants),
      variants = product.variants,
      found = false;

  variants.forEach((variant, index) => {
    var satisfied = true;

    selectedValues.forEach((option, index) => {
      if (satisfied) satisfied = (option.value === variant[option.index]);
    });

    if (satisfied) found = variant;
  });

  return found || null;
}

// Extracts all the current options
function getCurrentOptions(productVariants) {
  var options = productVariants.querySelectorAll('.option-selector:not([data-action])'),
      optionsArray = [];

  options.forEach((element) => {
    var optionType = element.getAttribute('data-selector-type'),        
        optionIndex = element.getAttribute('data-option-index'),
        selectedOption = '',
        selectedValue = '';

    if (optionType == 'swatches') {
      selectedOption = element.querySelector('.swatch-item[selected="selected"]');
      selectedValue = selectedOption.querySelector('.swatch-input').value;
    } else {
      selectedOption = element.querySelector('option[selected="selected"]');
      selectedValue = selectedOption.value;
    }

    optionsArray.push({value: selectedValue, index: optionIndex});
  });

  return optionsArray;
};

// Selects and changes the style of the new option
function selectProductOption() {
  var target = event.currentTarget,
      optionSelector = target.closest('.option-selector'),
      optionType = optionSelector.getAttribute('data-selector-type'),
      oldSelectedOption = optionSelector.querySelector('.swatch-item[selected="selected"]'),
      newSelectedOption = target.closest('.swatch-item'),
      action = optionSelector.dataset.action;

  if (optionType == 'select') {
    oldSelectedOption = optionSelector.querySelector('option[selected="selected"]');
    newSelectedOption = optionSelector.querySelectorAll('option')[optionSelector.selectedIndex];
  }
  
  oldSelectedOption.removeAttribute('selected');
  newSelectedOption.setAttribute('selected', 'selected');

  // If we need to redirect to a new product page or load a new product
  var itemProduct = target.closest('.item-product'),
      redirectUrl = newSelectedOption.dataset.url;
  
  if (action == 'redirect') {
    !isInModal(target) ? window.location.href = redirectUrl : toggleQuickShop(redirectUrl + '?view=quick_shop');
  } else if (action == 'change-product') {
    var url = window.theme.allProductsUrl;
    
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
          var container = document.createElement('div');
      
          container.innerHTML = text;
        
          var responseProduct = container.querySelector('.item-product[data-product-url="' + redirectUrl + '"]');
    
          if (responseProduct !== null) {
            var cssClass = itemProduct.getAttribute('class'),
                itemStyle = itemProduct.dataset.itemStyle,
                contentPosition = itemProduct.dataset.contentPosition,
                contentVerticalPosition = itemProduct.dataset.contentVerticalPosition,
                contentHorizontalPosition = itemProduct.dataset.contentHorizontalPosition;
    
            responseProduct.setAttribute('class', cssClass);
            responseProduct.setAttribute('data-item-style', itemStyle);
            responseProduct.setAttribute('data-content-position', contentPosition);
            responseProduct.setAttribute('data-content-vertical-position', contentVerticalPosition);
            responseProduct.setAttribute('data-content-horizontal-position', contentHorizontalPosition);
            itemProduct.outerHTML = responseProduct.outerHTML;
            setupEventListenersAfterFetchingProductItem();
          }
      })
      .finally(() => {
        
      })
      .catch((event) => {
        console.error(event);
      });
  }
}

// Creates the event listeners needed after fetch
function setupEventListenersAfterFetchingProductItem() {
  setupEventListenersForProductsItems();
}

// Selects the new variant
function selectProductNewVariant(productVariants, product) {
  var container = productVariants.closest('.main');
  
  if (!isPage('/products/') || container === null) container = productVariants.closest('.section__page');

  var variantIdContainers = container.querySelectorAll('.product-form'),
      productVariantsContainerss = container.querySelectorAll('.product__variants[data-context="page"]');

  if (isInProductCard(productVariants)) {
    container = productVariants.closest('.item-product');
    variantIdContainers = container.parentNode.querySelectorAll('.item-product'),
    productVariantsContainerss = container.querySelectorAll('.product__variants[data-context="card"]');
  }

  var currentVariant = getVariantFromOptions(productVariants, product);

  if (currentVariant) {
    var currentVariantId = currentVariant.id;

    // Updates the selected variant in the variant id container
    variantIdContainers.forEach((element) => {        
      element.setAttribute('data-variant-id', currentVariantId);
    });

    // Updates the selected variant in the hidden select
    productVariantsContainerss.forEach((element) => {
      var hiddenSelect = element.querySelector('[name="id"]');
      
      if (hiddenSelect.children.length > 0) {
        hiddenSelect.querySelector('[selected]').removeAttribute('selected');
        hiddenSelect.querySelector('[value="' + currentVariantId + '"]').setAttribute('selected', 'selected');
      }
    });

    // Updates the HTML history state if we are not on the quick shop view, neither in a product item
    if (!isInModal(container) && !isInProductCard(productVariants)) updateHistoryState(currentVariant);

    // Updates the urls on the product card to match the new variant url
    if (isInProductCard(productVariants)) {
      var variantUrl = window.theme.localeRootUrl + '/products/' + product.handle + '?variant=' + currentVariant.id;
      
      container.querySelectorAll('a[href]').forEach((element) => {
        element.setAttribute('href', variantUrl);
      });
    }
  }

  return currentVariant;
}

// Updates the HTML history state
function updateHistoryState(variant) {
  if (!history.replaceState) return;

  var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
    
  window.history.replaceState({path: newUrl}, '', newUrl);
}

// Updates the labels of the new variant
function updateProductLabels(currentVariant) {
  var target = event.currentTarget,
      container = target.closest('.main');
  
  if (!isPage('/products/') || container === null) container = target.closest('.section__page');

  var productLabels = container.querySelectorAll('.block.block__product-labels');

  if (isInProductCard(target)) {
    container = target.closest('.item-product');
    productLabels = container.querySelectorAll('.block__product-labels');
  }

  if (productLabels !== null) {
    productLabels.forEach((element) => {
      var productOnSaleLabel = element.querySelector('.label--on-sale'),
          productSoldOutLabel = element.querySelector('.label--sold-out');
  
      if (productOnSaleLabel !== null) productOnSaleLabel.remove();
      if (productSoldOutLabel !== null) productSoldOutLabel.remove();
  
      // Updates the "on sale" labels
      if (currentVariant.compare_at_price > currentVariant.price) {
        var discountAmount = currentVariant.compare_at_price - currentVariant.price,
            discountPercent = Math.round(discountAmount * 100 / currentVariant.compare_at_price),
            onSaleLabel = window.languages.onSaleLabel + ' -' + discountPercent + '%',
            newOnSaleLabelHtml = document.createElement('span'),
            newOnSaleLabelContent = document.createTextNode(onSaleLabel);

        newOnSaleLabelHtml.setAttribute('class', 'label product-label label--on-sale');
        newOnSaleLabelHtml.appendChild(newOnSaleLabelContent);  
        element.querySelector('.product-labels--inner').appendChild(newOnSaleLabelHtml);
      }
  
      // Updates the "sold out" labels
      var inventoryManagement = currentVariant.inventory_management,
          currentVariantAvailable = currentVariant.available;
  
      if (inventoryManagement != 'shopify' && element.querySelector('.label--sold-out') !== null) currentVariantAvailable = false;
      
      if (!currentVariantAvailable) {
        var newSoldOutLabelHtml = document.createElement('span'),
            newSoldOutLabelContent = document.createTextNode(window.languages.soldOutLabel);

        newSoldOutLabelHtml.setAttribute('class', 'label product-label label--sold-out');
        newSoldOutLabelHtml.appendChild(newSoldOutLabelContent);   
        element.querySelector('.product-labels--inner').appendChild(newSoldOutLabelHtml);
      }
    });
  }
}

// Updates the prices of the new variant
function updateProductPrices(currentVariant) {
  var target = event.currentTarget,
      container = target.closest('.main');
  
  if (!isPage('/products/') || container === null) container = target.closest('.section__page');

  var productPrices = container.querySelectorAll('.block.block__product-price');

  if (isInProductCard(target)) {
    container = target.closest('.item-product');
    productPrices = container.querySelectorAll('.block__product-price');
  }

  if (productPrices !== null) {
    productPrices.forEach((element) => {
      var productPrice = element.querySelector('.product-price');
  
      productPrice.innerHTML = '';
      
      if (currentVariant.compare_at_price > currentVariant.price) {
        var oldPriceHtml = document.createElement('span'),
            newPriceHtml = document.createElement('span'),
            oldPriceContent = document.createTextNode(Shopify.formatMoney(currentVariant.compare_at_price, window.theme['moneyFormat'])),
            newPriceContent = document.createTextNode(Shopify.formatMoney(currentVariant.price, window.theme['moneyFormat']));

        oldPriceHtml.setAttribute('class', 'product-price--value product-price--old');
        newPriceHtml.setAttribute('class', 'product-price--value product-price--new');
        oldPriceHtml.setAttribute('data-money-convertible', '');
        newPriceHtml.setAttribute('data-money-convertible', '');
        oldPriceHtml.appendChild(oldPriceContent);
        newPriceHtml.appendChild(newPriceContent);
        productPrice.appendChild(oldPriceHtml);
        productPrice.appendChild(newPriceHtml);
      } else {
        var normalPriceHtml = document.createElement('span'),
            normalPriceContent = document.createTextNode(Shopify.formatMoney(currentVariant.price, window.theme['moneyFormat']));

        normalPriceHtml.setAttribute('class', 'product-price--value product-price--normal');
        normalPriceHtml.setAttribute('data-money-convertible', '');
        normalPriceHtml.appendChild(normalPriceContent);
        productPrice.append(normalPriceHtml);
      }
    });
  }
}

// Updates the inventory of the new variant
function updateProductInventory(currentVariant) {
  var target = event.currentTarget,
      container = target.closest('.main');
  
  if (!isPage('/products/') || container === null) container = target.closest('.section__page');

  var productInventories = container.querySelectorAll('.block.block__product-inventory');

  if (isInProductCard(target)) {
    container = target.closest('.item-product');
    productInventories = container.querySelectorAll('.block__product-inventory');
  }

  var productVariants = target.closest('.product__variants'),
      hiddenSelect = productVariants.querySelector('[name="id"]'),
      inventoryHtml = window.languages.inventoryNormalHtml,
      inventoryState = 'normal';

  if (hiddenSelect.children.length > 0) {
    var newInventoryManagement = hiddenSelect.querySelector('[selected]').dataset.inventoryManagement,
        newInventoryPolicy = hiddenSelect.querySelector('[selected]').dataset.inventoryPolicy,
        newInventoryQuantity = parseInt(hiddenSelect.querySelector('[selected]').dataset.inventoryQuantity); 
  }

  if (productInventories !== null) {    
    productInventories.forEach((element) => {
      var productInventory = element.querySelector('.product-inventory'),
          productInventoryState = productInventory.dataset.inventoryState,
          showQuantity = productInventory.dataset.showQuantity,
          inventoryLowLimit = parseInt(productInventory.dataset.limit);
      
      if (newInventoryManagement == 'shopify') {
        if (showQuantity == 'true') inventoryHtml = window.languages.inventoryNormalCountHtml;
    
        if (newInventoryQuantity == 0) {
          if (newInventoryPolicy == 'deny') {
            showQuantity == 'true' ? inventoryHtml = window.languages.inventoryZeroCountHtml : inventoryHtml = window.languages.inventoryZeroHtml;
            inventoryState = 'zero';
          }
        } else if (newInventoryQuantity < inventoryLowLimit) {
          showQuantity == 'true' ? inventoryHtml = window.languages.inventoryLowCountHtml : inventoryHtml = window.languages.inventoryLowHtml;
          inventoryState = 'low';
        }
      } else {
         inventoryHtml = window.languages.inventoryNormalHtml,
         inventoryState = 'normal';
  
        if (productInventoryState == 'zero') {
          inventoryHtml = window.languages.inventoryZeroHtml;
          inventoryState = 'zero';
        } else if (productInventoryState == 'low') {
          inventoryHtml = window.languages.inventoryLowHtml;
          inventoryState = 'low';
        }
      }
  
      productInventory.querySelector('.product-inventory-label').innerHTML = inventoryHtml;
      if (productInventory.querySelector('.inventory-quantity') !== null) productInventory.querySelector('.inventory-quantity').innerHTML = newInventoryQuantity;
      productInventory.classList.remove('product-inventory--zero', 'product-inventory--low', 'product-inventory--normal');
      productInventory.classList.add('product-inventory--' + inventoryState);
    });
  }
}

// Updates the images of the new variant
function updateProductImages(currentVariant) {
  var target = event.currentTarget;
  
  if (!isInProductCard(target)) {
    var container = target.closest('.section__page');
    
    if (currentVariant.featured_media) {
      var productSlideshows = container.querySelectorAll('.carousel--media-prod');

      productSlideshows.forEach((element) => {
        var productSlideshowImages = element.querySelectorAll('.carousel-cell'),
            productSlideshowImagesArray = [...productSlideshowImages],
            mediaToFind = productSlideshowImagesArray.filter((image) => image.dataset.mediaId == currentVariant.featured_media.id),
            thumbnailToFind = productSlideshowImagesArray.filter((image) => image.dataset.mediaId == currentVariant.featured_media.id && image.dataset.thumbnail == 'true');
        
        if (mediaToFind[0] && isSliderInitialized(element)) element.closest('.carousel').swiper.slideTo(parseInt(mediaToFind[0].getAttribute('data-slide-index')), parseInt(element.dataset.speed), false);
        if (thumbnailToFind[0]) thumbnailToFind[0].click();
      });
    }
  } else {
    var container = target.closest('.item-product');
  
    if (currentVariant.featured_media) {
      var images = container.querySelectorAll('.image:not(.hover)'),
          newImageUrl = currentVariant.featured_image.src;        
      
      images.forEach((element) => {
        var image = element.querySelector('img'),
            imageSrc = image.getAttribute('src').split('&width').shift(),
            imageSrcSet = image.getAttribute('srcset');

        imageSrcSet = imageSrcSet.replaceAll(imageSrc, newImageUrl);
        image.setAttribute('srcset', imageSrcSet);
        image.setAttribute('src', newImageUrl);
      });
    }
  }
}

// Checks if the new variant selected is available
function checkProductVariantAvailability(currentVariant, productVariants) {
  var target = event.currentTarget,
      container = target.closest('.main'),
      productVariantsContainerss = null,
      ctas = null,
      shopifyPaymentButtons = null,
      inventoryManagement = currentVariant.inventory_management;
  
  if (!isPage('/products/') || container === null) container = target.closest('.section__page');

  if (container !== null) {
    productVariantsContainerss = container.querySelectorAll('.product__variants[data-context="page"]'),
    ctas = container.querySelectorAll('.product__add-to-cart'),
    shopifyPaymentButtons = container.querySelectorAll('.shopify-payment-button');
  }

  if (isInProductCard(target)) {
    container = target.closest('.item-product');
    productVariantsContainerss = container.querySelectorAll('.product__variants[data-context="card"]'),
    ctas = container.querySelectorAll('.block__button .button');
  }

  if (inventoryManagement == 'shopify') {
    // Changes the style of the options
    productVariantsContainerss.forEach((element) => {
      var soldOutOptions = element.querySelectorAll('.option-selector [disabled="disabled"]'),
          selectedOptions = element.querySelectorAll('.option-selector [selected="selected"]');
  
      soldOutOptions.forEach((element) => {
        element.classList.remove('sold-out');
        element.removeAttribute('disabled');
      });
      
      if (!currentVariant || !currentVariant.available) {
        selectedOptions.forEach((element) => {
          element.classList.add('sold-out');
          element.setAttribute('disabled', 'disabled');
        });
      }
    });

    // Updates the quantity selector so that customers can't order more products than the available quantity
    // NOTE: Not possible to retrieve a variant inventory_policy and inventory_quantity from json
    /*
    var quantitySelector = productForm.querySelector('.product__quantity-wrapper'),
        currentVariantInventoryPolicy = currentVariant.inventory_policy,
        currentVariantMaxQuantity = currentVariant.inventory_quantity;

    if (currentVariantInventoryPolicy == 'deny') {
      quantitySelector.setAttribute('data-max', currentVariantMaxQuantity);
      quantitySelector.querySelector('input[type="number"]').setAttribute('max', currentVariantMaxQuantity);
    }
    */

    // Updates ctas state
    ctas.forEach((element) => {
      var ctaText = element.dataset.buttonTextEnable;

      if (isInProductCard(target)) ctaText = element.dataset.buttonText;
      
      element.removeAttribute('disabled');
      element.querySelector('.button-text').textContent = ctaText;

      if (!isInProductCard(target)) {
        if (!currentVariant || !currentVariant.available) ctaText = element.dataset.buttonTextDisable;
      } else {
        !currentVariant ? ctaText = window.languages.unavailableButton : ctaText = window.languages.soldOutButton;
      }
      
      if (!currentVariant || !currentVariant.available) {
        element.setAttribute('disabled', 'disabled');
        element.querySelector('.button-text').textContent = ctaText;
      }
    });

    // Updates shopify payment buttons state
    if (shopifyPaymentButtons !== null) {
      shopifyPaymentButtons.forEach((element) => {
        element.css.display = 'block';
        if (!currentVariant || !currentVariant.available) element.css.display = 'none';
      });
    }
  }
}

// Updates the price of the selection in the subscription insert
function updateSubscriptionPrices() {
  var target = event.currentTarget,
      container = target.closest('.main');

  if (isInModal(target)) container = target.closest('.modal');
  
  var productSubscriptions = container.querySelectorAll('.product__subscription'),
      productForm = container.querySelector('.product__form');
  
  if (productForm !== null) var smartrrUniqueId = productForm.getAttribute('data-smartrr-form-id');

  productSubscriptions.forEach((element) => {
    if (window.smartrrProductList && window.smartrrProductList[smartrrUniqueId]) {
      var productInfo = window.smartrrProductList[smartrr_unique_id];
  
      productInfo.ui.logic.apiChangePlan(productInfo.ui.logic.apiGetCurrentCopy().planId);
    }
  });
}